import React from 'react';

import BaseOAuthButton from './BaseOAuthButton';

import Icon from '../assets/google.svg';
import { BaseOAuthProps } from '../types';

const GoogleOAuthButton: React.FC<BaseOAuthProps> = (props) => {
    return <BaseOAuthButton {...props} label="Google" apiUrl="/api/v3/oauth/google" icon={<Icon />} />;
};

export default GoogleOAuthButton;
